module.exports = __webpack_public_path__ + "static/media/12-Rostock@3x.df994c14.jpg";